import React, { useEffect } from "react";
import { Box } from "@material-ui/core";
import useStyles from "./styles";
import TargetApproval from "./TargetApproval";

const TargetCompletion = props => {
  const classes = useStyles();
  useEffect(() => {
    if (props.open) {
      setTimeout(function () {
        props.setOpen(false);
      }, 4000);
    }
  }, [props.open]);
  return (
    <Box className={classes.targetCompletionConfetti}>
      <TargetApproval
        message={props.message}
      />
    </Box>
  );
};

export default TargetCompletion;
